import { useMenuVariant } from 'experiments/menu-variant/use-menu-variant';
import { IFeatureMenuQuery, useFeatureMenuQuery } from 'generated/sanity-graphql';
import { useAdaptableMenuCardsQuery } from 'hooks/use-adaptable-menu-cards-query';
import { useFeaturesContext } from 'state/features';
import { withSimpleCache } from 'state/graphql/with-simple-cache';

interface IUseFeatureMenuValue {
  menuId: string;
  featureMenu: IFeatureMenuQuery['FeatureMenu'];
  featureMenuLoading: boolean;
}

const useCachedFeatureMenuQuery = withSimpleCache(useFeatureMenuQuery);

export const useFeatureMenu = (): IUseFeatureMenuValue => {
  const { featureMenuId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useCachedFeatureMenuQuery({
    variables: { featureMenuId },
    skip: !featureMenuId,
  });
  // Querying to cache data when feature menu loads
  // This query will skip if feature is not enable in Amplitude Experiments to avoid
  // querying data
  useAdaptableMenuCardsQuery(featureMenuId);

  const featureMenu = data?.FeatureMenu ?? null;
  const menuVariant = useMenuVariant(featureMenu);
  const menuId = menuVariant?.menuVariantId || featureMenu?.defaultMenu?._id || '';

  const featureMenuLoading = featureIdsLoading || loading;

  return {
    menuId,
    featureMenu,
    featureMenuLoading,
  };
};
